"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefault = exports.isCase = void 0;
const Case_1 = require("./Case");
const Default_1 = require("./Default");
function isCase(child) {
    return child.type === Case_1.Case;
}
exports.isCase = isCase;
function isDefault(child) {
    return child.type == Default_1.Default;
}
exports.isDefault = isDefault;
//# sourceMappingURL=utilities.js.map